import { ERROR_MESSAGES } from 'utility/errors/errorMessages';

const GENERIC_ERROR_MSG = ERROR_MESSAGES[500];
export default GENERIC_ERROR_MSG;
